export const getTeamMemberDisplayName = (member: TTeamMember): string =>
    member.first_name || member.last_name
        ? `${member.first_name ?? ''} ${member.last_name ?? ''}`.trim()
        : member.email
